import { DateTime } from "luxon";

export const BACKEND_TIME_FORMAT = 'HH:mm:ss';
export const BACKEND_DATE_FORMAT = 'yyyy-MM-dd';
export const BACKEND_DATETIME_FORMAT = 'yyyy-MM-dd\'T\'HH:mm:ss\'Z\'';
export const FRONTEND_TIME_FORMAT_OPTIONS = DateTime.TIME_SIMPLE;
export const FRONTEND_DATE_FORMAT_OPTIONS = DateTime.DATE_SHORT;
export const FRONTEND_DATETIME_FORMAT_OPTIONS = DateTime.DATETIME_SHORT;
export const EMAIL_REG = /^[\+\w-\.]+@([\w-]+\.)+[\w-]{2,20}$/;

export const DEBOUNCE_SEARCH_TIME = 1000;
